import React, { useRef, useState, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useTheme, lighten } from "@mui/material/styles";
import { v4 as uuid } from "uuid";
import { Button, Typography, Dialog, DialogContent, Grid } from "@mui/material";
import { StyledDialogActions } from "./styles";
import { State, Props } from "./interfaces";
import SignaturePad from "react-signature-pad-wrapper";

const SignaturePadContainer = ({ text, refOBj }: Props) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const tRP = "components.signature_pad";

  return (
    <>
      <Grid
        style={{
          borderColor: lighten(theme.palette.secondary.light, 0.2),
          borderStyle: "solid",
          alignContent: "center",
          alignItems: "center",
          justifyContent: "center",
          borderRadius: "5px",
        }}
      >
        <Typography
          sx={{
            fontSize: "1.2em",
            fontStyle: "italic",
            fontWeight: 800,
          }}
        >
          {text}
        </Typography>
        <SignaturePad
          options={{
            minWidth: 2,
            maxWidth: 3,
            penColor: "rgb(66, 133, 244)",
            backgroundColor: "rgb(240, 240, 240)",
          }}
          ref={refOBj}
          redrawOnResize
        />
      </Grid>
    </>
  );
};

export default SignaturePadContainer;
